import { InfoHubLayout } from 'views/InfoHub/Layout'
import TotalView from 'views/InfoHub/TotalView'

const InfoPage = () => <TotalView />
InfoPage.Layout = InfoHubLayout
InfoPage.chains = [] // set all
export default InfoPage
